/*
====================================================================
                        Servicio fetchLogin
====================================================================
Este servicio maneja la solicitud de inicio de sesión hacia el backend.
Envía las credenciales del usuario (correo y contraseña) a la API y 
devuelve la respuesta de la solicitud.

- Utiliza el método POST para enviar las credenciales.
- Las credenciales se envían en formato JSON en el cuerpo de la solicitud.
- La URL de la API se configura mediante la variable de entorno `V_URL_API`.

====================================================================
*/

// ------------------------------------------------------------------
//                            IMPORTS
// ------------------------------------------------------------------
// Importación de entidades y configuración necesarias.

import LoginEntity from '../../../core/entities/loginEntity';
import { V_URL_API } from '../../../utils/config';

// ------------------------------------------------------------------
//                       DEFINICIÓN DEL SERVICIO
// ------------------------------------------------------------------
/**
 * Envía una solicitud de inicio de sesión al backend.
 * 
 * Este servicio toma una instancia de `LoginEntity` que contiene las 
 * credenciales del usuario (correo y contraseña) y las envía al servidor 
 * mediante una solicitud `POST`. La respuesta de la API se devuelve para 
 * su manejo en el frontend.
 * 
 * @param {LoginEntity} loginEntity - Una instancia de `LoginEntity` que contiene el correo y la contraseña del usuario.
 * @returns {Promise<Response>} La respuesta de la API.
 */
export async function fetchEnviarMensaje(vDatosContactanos) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(vDatosContactanos);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };
    // Realiza la solicitud `POST` a la API de inicio de sesión
    return await fetch(`${V_URL_API}/api/contactanos/`, requestOptions);
}
